import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
  Modal,
  ModalFooter,
  Row,
  TextField,
} from '@folio/stripes-components';
import { FormattedMessage, useIntl } from 'react-intl';

function GoToModal({
  onClose,
  open,
  mode, // 'index' or 'barcode'
  onGoTo,
}) {
  const [inputValue, setInputValue] = useState('');
  const intl = useIntl();

  const onCloseModal = () => {
    setInputValue('');
    onClose();
  };

  const handleGoTo = () => {
    if (!inputValue || inputValue.trim() === '') {
      return;
    }

    onGoTo(inputValue.trim(), mode);
    onCloseModal();
  };

  const isIndexMode = mode === 'index';

  const renderFooter = () => {
    return (
      <ModalFooter>
        <Button
          id="cancel-go-to-modal"
          buttonStyle="default"
          onClick={onCloseModal}
          marginBottom0
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.cancel"
            defaultMessage="Cancel"
          />
        </Button>
        <Button
          id="go-to-submit"
          buttonStyle="primary"
          onClick={handleGoTo}
          disabled={!inputValue || inputValue.trim() === ''}
          marginBottom0
        >
          <FormattedMessage id="ui-plugin-inventory-templates.goToModal.goButton" defaultMessage="Go" />
        </Button>
      </ModalFooter>
    );
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleGoTo();
    }
  };

  return (
    <Modal
      open={open}
      onClose={onCloseModal}
      label={intl.formatMessage({
        id: isIndexMode ? 'ui-plugin-inventory-templates.goToModal.index.title' : 'ui-plugin-inventory-templates.goToModal.barcode.title',
        defaultMessage: isIndexMode
          ? 'Navigate by Index'
          : 'Navigate by Barcode',
      })}
      footer={renderFooter()}
      size="small"
      dismissible
    >
      <Row>
        <Col xs={12}>
          <TextField
            label={intl.formatMessage({
              id: isIndexMode
                ? 'ui-plugin-inventory-templates.goToModal.index.label'
                : 'ui-plugin-inventory-templates.goToModal.barcode.label',
              defaultMessage: isIndexMode ? 'Item Index' : 'Item Barcode',
            })}
            placeholder={intl.formatMessage({
              id: isIndexMode
                ? 'ui-plugin-inventory-templates.goToModal.index.placeholder'
                : 'ui-plugin-inventory-templates.goToModal.barcode.placeholder',
              defaultMessage: isIndexMode
                ? 'Enter item index (e.g., 100)'
                : 'Enter barcode (e.g., ABC123)',
            })}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            type={isIndexMode ? 'number' : 'text'}
            onKeyDown={handleKeyPress}
            autoFocus
            required
          />
        </Col>
      </Row>
    </Modal>
  );
}

GoToModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  mode: PropTypes.oneOf(['index', 'barcode']).isRequired,
  onGoTo: PropTypes.func.isRequired,
};

export default GoToModal;
